/* Klarta US — Klarta app (/pages/app).
   Setup step 4 — model switcher. The page's only JavaScript.
   Without it both panels render and the button group hides itself (<noscript>
   rule in the section), so every instruction stays reachable. aria-pressed, not
   aria-expanded: these buttons select between two sets of instructions, they do
   not disclose one. Idempotent; re-runs on shopify:section:load. */
(function () {
  function init() {
    var groups = [].slice.call(document.querySelectorAll('.app-switch'));
    groups.forEach(function (group) {
      if (group.getAttribute('data-app-init') === '1') return;

      var buttons = [].slice.call(group.querySelectorAll('button[data-app-target]'));
      var scope = group.closest('.app-steps__body') || document;
      var panels = [].slice.call(scope.querySelectorAll('.app-panel'));
      if (!buttons.length || !panels.length) return;
      group.setAttribute('data-app-init', '1');

      function show(id) {
        buttons.forEach(function (b) {
          b.setAttribute('aria-pressed', String(b.getAttribute('data-app-target') === id));
        });
        panels.forEach(function (p) { p.hidden = (p.id !== 'app-' + id); });
      }

      group.addEventListener('click', function (e) {
        var b = e.target.closest ? e.target.closest('button[data-app-target]') : null;
        if (b) show(b.getAttribute('data-app-target'));
      });

      show('purifier');   // JS-only default; with JS off both panels stay visible
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
